export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";